import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { UserColorService } from '../services/user-color.service';
import { UserProfileDto } from '@core/services/api-clients';
import { WebResourceUriPipe } from '../../../shared/utils/pipes/relative-to-webresource-base64uri.pipe';

@Component({
    selector: 'app-user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrls: ['./user-avatar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, WebResourceUriPipe]
})
export class UserAvatarComponent {
  private readonly _colorService = inject(UserColorService);

  readonly user = input<UserProfileDto>(null);
  readonly size = input<number>(undefined);
  isHovered = false;

  getUsernameAcronym(): string {
    const user = this.user();
    if (!user?.displayName?.length) return '';
    const username = user.displayName;
    const splittedUsername = username.split(' ');
    const isOneWord = splittedUsername.length == 1;
    const isOneLetter = isOneWord && splittedUsername[0].length == 1;
    if (isOneLetter) return splittedUsername[0][0] + splittedUsername[0][0];
    if (isOneWord) return splittedUsername[0][0] + splittedUsername[0][1];
    return splittedUsername[0][0] + splittedUsername[1][0];
  }

  getUserColor(): string {
    return this._colorService.getUserColor(this.user());
  }
}
